import * as api from "../../api";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";

import { ALERT } from "../../constants/actionTypes";

import Logo from "../../images/logo.svg";

import "./Confirmation.css";

const Confirmation = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = match.params.token;

  useEffect(() => {
    const verirfy = async () => {
      try {
        await api.confirmEmail({ token });
      } catch (error) {
        if (error.response)
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: error.response.data.message,
              duration: 5000,
              display: true,
            },
          });
        else
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: "An unexpected error occurred",
              duration: 5000,
              display: true,
            },
          });
      } finally {
        history.replace("/auth/signin");
      }
    };

    verirfy();
  });

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex align-center justify-center w-100 h-100"
    >
      <div className="confirmation__ctn d-flex flex-column align-center p-20 text-center">
        <img src={Logo} alt="" />
        <h1>Confirming Email</h1>
        <p className="font-heavy py-20">
          Please wait as we verify your email address
        </p>
        <div className="spin-large my-20"></div>
      </div>
    </div>
  );
};

export default Confirmation;
